module.exports = __webpack_public_path__ + "media/images/icons/notes-45ad377de46efc238b6240440834939f.svg";